export const MIXPANEL_TOKEN = 'ccccc694ae9983c6c2252909d0a174d4';